import { NgClass } from '@angular/common';
import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

@Component({
  selector: 'zui-separator',
  templateUrl: './separator.component.html',
  styleUrls: ['./separator.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [ NgClass ]
})
export class ZuiSeparatorComponent {

  @Input()
  orientation: 'horizontal' | 'vertical' = 'vertical';

  @Input()
  size: 'mini' | 'small' | 'medium' | 'large' = 'medium';

  @Input()
  spacing: 'none' | 'mini' | 'small' | 'bu' |  'medium' | 'large' | 'big' | 'huge' | 'humongous' | 'disabled' = 'medium';

  @Input()
  position: 'center' | 'start' | 'end' = 'center';

  @Input()
  isZen: boolean;

}
